import React from "react";
import { PlanCell } from "../../data/plan";
import { PurchaseDto } from "../../api";
import {
  formatPlanCellDescription,
  isNewOrEdited,
} from "../../utils/planUtils";
import { isDeleted } from "../../utils/editUtils";
import { colors } from "../../theme/colors";

export function PlanCellTag(props: {
  planCell: PlanCell;
  mealIndex: number;
  purchases: PurchaseDto[];
  onClick: React.MouseEventHandler<HTMLSpanElement>;
}) {
  const description = formatPlanCellDescription(
    props.planCell,
    props.purchases,
  );
  const isWithoutIntakes =
    props.planCell.indicator == "MealWithIntakes" && !props.planCell.intakes;
  const color = isNewOrEdited(props.planCell)
    ? colors.goldTag
    : isWithoutIntakes
      ? undefined
      : "var(--p2p-inactive-bg)";
  const textDecoration = isDeleted(props.planCell) ? "line-through" : undefined;
  const border = isWithoutIntakes ? "1px dashed var(--p2p-muted)" : undefined;
  const textColor = isWithoutIntakes ? "var(--p2p-muted)" : undefined;
  return (
    <span
      data-cy="plan-cell-tag"
      onClick={props.onClick}
      className="mr-[5px] mb-[5px] inline-flex h-fit items-center rounded-pill bg-surface px-2.5 py-0.5 text-xs font-medium text-ink"
      style={{
        backgroundColor: color,
        textDecoration,
        border,
        color: textColor,
      }}
    >
      {description}
    </span>
  );
}
